export class PinCodeNotCreatedError extends Error {
    constructor() {
        super();
        this.message = 'Pin code not created';
    }
}
